export const adapter = {
    "a7": {
        "info": [
            { "desc": "bayonet", "dim": ["7x2.6mm"] }
        ]
    },
    "b": {
        "info": [
            { "desc": "hook", "dim": ["7x2.5mm", "9x3mm"] },
        ]
    },
    "b1": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm", "9x4mm"] }
        ]
    },
    "b3": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm", "9x4mm"] },
            { "desc": "bayonet", "dim": ["7x2.6mm"] },
            { "desc": "pin clip", "dim": ["3/16 pin arm", "1/4 pin arm"] }
        ]
    },
    "b6": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm"] }
        ]
    },
    "bl-2a": {
        "info": [
            { "desc": "bayonet hook", "dim": ["9x3mm"] }
        ]
    },
    "c": {
        "info": [
            { "desc": "hook", "dim": ["6x2mm", "8x3mm"] }
        ]
    },
    "c0": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm", "9x4mm"] },
        ]
    },
    "c1": {
        "info": [
            { "desc": "hook", "dim": ["6x2mm", "8x3mm"] },
            { "desc": "bayonet", "dim": ["5x2mm"] },
            { "desc": "pin clip", "dim": ["- -"] }
        ]
    },
    "c1-2": {
        "name": 'c1',
        "info": [
            { "desc": "top lock", "dim": ["19mm"] }
        ]
    },
    "c2": {
        "info": [
            { "desc": "top lock", "dim": ["16mm"] }
        ]
    },
    "c3": {
        "info": [
            { "desc": "PINCH TAB", "dim": ["- -"] }
        ]
    },
    "c4": {
        "info": [
            { "desc": "SIDE PIN", "dim": ["- -"] }
        ]
    },
    "c5": {
        "info": [
            { "desc": "MERCEDES LOCK", "dim": ["- -"] }
        ]
    },
    "c6": {
        "info": [
            { "desc": "TOP LOCK C (ASMO)", "dim": ["- -"] }
        ]
    },
    "c7": {
        "info": [
            { "desc": "KEY LOCK", "dim": ["- -"] }
        ]
    },
    "c9": {
        "info": [
            { "desc": "PINCH LOCK", "dim": ["- -"] }
        ]
    },
    "c10": {
        "info": [
            { "desc": "TOP LOCK (HYUNDAI)", "dim": ["- -"] }
        ]
    },
    "cl+cl-r": {
        "name": 'cl+clr',
        "info": [
            { "desc": "central lock", "dim": ["- -"] }
        ]
    },
    "d2": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm"] }
        ]
    },
    "d4": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm"] }
        ]
    },
    "e1": {
        "info": [
            { "desc": "C1+C2+C3+C4", "dim": ["- -"] }
        ]
    },
    "ehd": {
        "info": [
            { "desc": "Hook", "dim": ["9x3mm", "9x4mm"] }
        ]
    },
    "ehs": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm", "9x4mm"] },
            { "desc": "big pin", "dim": ["- -"] }
        ]
    },
    "dpj": {
        "info": [
            { "desc": "mounting base", "dim": ["- -"] }
        ]
    },
    "f": {
        "info": [
            { "desc": "hook", "dim": ["9x4mm"] }
        ]
    },
    "f1": {
        "info": [
            { "desc": "hook", "dim": ["9x4mm"] }
        ]
    },
    "f2": {
        "info": [
            { "desc": "hook", "dim": ["12x4mm"] }
        ]
    },
    "f3": {
        "info": [
            { "desc": "hook", "dim": ["9x4mm"] }
        ]
    },
    "f4": {
        "info": [
            { "desc": "hook", "dim": ["9x4mm", "12x4mm"] }
        ]
    },
    "f6": {
        "info": [
            { "desc": "hook", "dim": ["9x4mm", "12x4mm"] }
        ]
    },
    "g1": {
        "info": [
            { "desc": "bayonet", "dim": ["9x3mm"] }
        ]
    },
    "j2": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm", "9x4mm"] }
        ]
    },
    "j3": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm"] }
        ]
    },
    "j4": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm"] }
        ]
    },
    "j5": {
        "info": [
            { "desc": "hook", "dim": ["9x3mm", "12x4mm"] }
        ]
    },
    "m3": {
        "info": [
            { "desc": "ph+pt+tl-2+tl4a", "dim": ["- -"] }
        ]
    },
    "m4": {
        "info": [
            { "desc": "bl-2a+pt6", "dim": ["- -"] }
        ]
    },
    "m5": {
        "info": [
            { "desc": "tla+tlc", "dim": ["- -"] }
        ]
    },
    "m6": {
        "info": [
            { "desc": "mtl+tl-2+pt3", "dim": ["- -"] }
        ]
    },
    "ml": {
        "info": [
            { "desc": "push button", "dim": ["- -"] }
        ]
    },
    "p": {
        "info": [
            { "desc": "insert pin", "dim": ["4.8mm"] }
        ]
    },
    "pb": {
        "info": [
            { "desc": "push button", "dim": ["- -"] }
        ]
    },
    "pc": {
        "info": [
            { "desc": "pin cover", "dim": ["4.8mm", "6.5mm"] }
        ]
    },
    "ph-2": {
        "info": [
            { "desc": "side pin", "dim": ["- -"] }
        ]
    },
    "ph-3": {
        "info": [
            { "desc": "side pin", "dim": ["- -"] }
        ]
    },
    "pj-j6": {
        "info": []
    },
    "pl": {
        "info": [
            { "desc": "pinch lock", "dim": ["- -"] }
        ]
    },
    "pt-3": {
        "info": [
            { "desc": "pinch tab", "dim": ["- -"] }
        ]
    },
    "pt6": {
        "info": [
            { "desc": "pinch tab", "dim": ["- -"] }
        ]
    },
    "pt-r": {
        "name": 'tl-b',
        "info": [
            { "desc": "pinch tab", "dim": ["- -"] }
        ]
    },
    "r0": {
        "info": [
            { "desc": "pinch tab arm", "dim": ["- -"] }
        ]
    },
    "r1": {
        "info": [
            { "desc": "pinch tab arm", "dim": ["- -"] }
        ]
    },
    "r2": {
        "info": [
            { "desc": "push button arm", "dim": ["- -"] }
        ]
    },
    "r3": {
        "info": [
            { "desc": "v-notch arm", "dim": ["- -"] }
        ]
    },
    "r4": {
        "info": [
            { "desc": "cross pin arm", "dim": ["- -"] }
        ]
    },
    "ra": {
        "info": [
            { "desc": "rock lock arm", "dim": ["- -"] }
        ]
    },
    "rb": {
        "info": [
            { "desc": "rock lock arm", "dim": ["- -"] }
        ]
    },
    "rc": {
        "info": [
            { "desc": "slide pinch arm", "dim": ["- -"] }
        ]
    },
    "rd": {
        "info": [
            { "desc": "snap claw arm", "dim": ["- -"] }
        ]
    },
    "rd+": {
        "info": [
            { "desc": "hook arm", "dim": ["- -"] }
        ]
    },
    "re+rec": {
        "info": [
            { "desc": "snap claw arm", "dim": ["- -"] }
        ]
    },
    "rg": {
        "info": [
            { "desc": "rock lock arm", "dim": ["- -"] }
        ]
    },
    "s": {
        "info": [
            { "desc": "side saddle (metal)", "dim": ["rhd", "lhd"] }
        ]
    },
    "s1": {
        "info": [
            { "desc": "side saddle (plastic)", "dim": ["rhd", "lhd"] }
        ]
    },
    "tc": {
        "info": [
            { "desc": "tube clip", "dim": ["- -"] }
        ]
    },
    "tl-2": {
        "name": 'tl-5',
        "info": [
            { "desc": "top lock(rhd/lhd)", "dim": ["- -"] }
        ]
    },
    "tl-b": {
        "info": [
            { "desc": "pinch tab ", "dim": ["- -"] }
        ]
    },
    "tl4a": {
        "info": [
            { "desc": "top lock", "dim": ["- -"] }
        ]
    },
    "tlc": {
        "info": [
            { "desc": "top lock c", "dim": ["- -"] }
        ]
    },
    "u": {
        "info": [
            { "desc": "spacer", "dim": ["16mm"] }
        ]
    },
    "u1": {
        "info": [
            { "desc": "spacer", "dim": ["25mm"] }
        ]
    },
    "u2": {
        "info": [
            { "desc": "spacer", "dim": ["27mm"] }
        ]
    },
    "u3a": {
        "info": [
            { "desc": "holder", "dim": ["16mm"] }
        ]
    },
    "u4a": {
        "info": [
            { "desc": "holder", "dim": ["14mm"] }
        ]
    },
    "r0-ur3": {
        "name": 'r0',
        "info": [
            { "desc": "pinch tab arm", "dim": ["- -"] }
        ]
    },
    "r1a-ur3": {
        "name": 'r1a',
        "info": [
            { "desc": "pinch tab arm", "dim": ["- -"] }
        ]
    },
    "r2-ur3": {
        "name": 'r2',
        "info": [
            { "desc": "push button arm", "dim": ["- -"] }
        ]
    },
    "r3-ur3": {
        "name": 'r3',
        "info": [
            { "desc": "v-notch arm", "dim": ["- -"] }
        ]
    },
    "r4-ur3": {
        "name": 'r4',
        "info": [
            { "desc": "cross pin arm", "dim": ["- -"] }
        ]
    },
    "r5-ur3": {
        "name": 'r5',
        "info": [
            { "desc": "top lock arm", "dim": ["- -"] }
        ]
    },
    "r6-ur3": {
        "name": 'r6',
        "info": [
            { "desc": "cross pin arm", "dim": ["- -"] }
        ]
    },
    "ra-ur3": {
        "name": 'ra',
        "info": [
            { "desc": "rock lock arm", "dim": ["- -"] }
        ]
    },
    "rb-ur3": {
        "name": 'rb',
        "info": [
            { "desc": "rock lock arm", "dim": ["- -"] }
        ]
    },
    "rc-ur3": {
        "name": 'rc',
        "info": [
            { "desc": "slide pinch arm", "dim": ["- -"] }
        ]
    },
    "rd-ur3": {
        "name": 'rd',
        "info": [
            { "desc": "snap claw arm", "dim": ["- -"] }
        ]
    },
    "rd+-ur3": {
        "name": 'rd+',
        "info": [
            { "desc": "hook arm", "dim": ["- -"] }
        ]
    },
    "re-ur3": {
        "name": 're',
        "info": [
            { "desc": "snap claw arm", "dim": ["- -"] }
        ]
    },
    "rec-ur3": {
        "name": 'rec',
        "info": [
            { "desc": "snap claw arm", "dim": ["- -"] }
        ]
    },
    "rg-ur3": {
        "name": 'rg',
        "info": [
            { "desc": "rock lock arm", "dim": ["- -"] }
        ]
    },
}